import React from 'react';
import Icon from '../../../components/AppIcon';

const SearchFilters = ({ searchQuery, onSearchChange, filters, onFiltersChange, viewMode, onViewModeChange }) => {
  const types = [
    { value: 'all', label: 'All Types' },
    { value: 'course', label: 'Courses' },
    { value: 'certification', label: 'Certifications' },
    { value: 'reference', label: 'Reference Materials' }
  ];

  const levels = [
    { value: 'all', label: 'All Levels' },
    { value: 'beginner', label: 'Beginner' },
    { value: 'intermediate', label: 'Intermediate' },
    { value: 'advanced', label: 'Advanced' }
  ];

  const formats = [
    { value: 'all', label: 'All Formats' },
    { value: 'video', label: 'Video' },
    { value: 'document', label: 'Document' },
    { value: 'interactive', label: 'Interactive' }
  ];

  const statuses = [
    { value: 'all', label: 'All Status' },
    { value: 'published', label: 'Published' },
    { value: 'draft', label: 'Draft' },
    { value: 'archived', label: 'Archived' }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-4">
      <div className="flex flex-wrap items-center gap-4">
        {/* Search Input */}
        <div className="flex-1 min-w-[300px]">
          <div className="relative">
            <Icon
              name="Search"
              size={20}
              className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground"
            />
            <input
              type="text"
              placeholder="Search training materials..."
              value={searchQuery}
              onChange={(e) => onSearchChange(e?.target?.value)}
              className="w-full pl-10 pr-4 py-2 bg-background border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary text-sm"
            />
          </div>
        </div>

        {/* Type Filter */}
        <select
          value={filters?.type}
          onChange={(e) => onFiltersChange({ ...filters, type: e?.target?.value })}
          className="px-3 py-2 bg-background border border-border rounded-lg text-sm font-medium focus:outline-none focus:ring-2 focus:ring-primary"
        >
          {types?.map((type) => (
            <option key={type?.value} value={type?.value}>
              {type?.label}
            </option>
          ))}
        </select>

        {/* Level Filter */}
        <select
          value={filters?.level}
          onChange={(e) => onFiltersChange({ ...filters, level: e?.target?.value })}
          className="px-3 py-2 bg-background border border-border rounded-lg text-sm font-medium focus:outline-none focus:ring-2 focus:ring-primary"
        >
          {levels?.map((level) => (
            <option key={level?.value} value={level?.value}>
              {level?.label}
            </option>
          ))}
        </select>

        {/* Format Filter */}
        <select
          value={filters?.format}
          onChange={(e) => onFiltersChange({ ...filters, format: e?.target?.value })}
          className="px-3 py-2 bg-background border border-border rounded-lg text-sm font-medium focus:outline-none focus:ring-2 focus:ring-primary"
        >
          {formats?.map((format) => (
            <option key={format?.value} value={format?.value}>
              {format?.label}
            </option>
          ))}
        </select>

        {/* Status Filter */}
        <select
          value={filters?.status}
          onChange={(e) => onFiltersChange({ ...filters, status: e?.target?.value })}
          className="px-3 py-2 bg-background border border-border rounded-lg text-sm font-medium focus:outline-none focus:ring-2 focus:ring-primary"
        >
          {statuses?.map((status) => (
            <option key={status?.value} value={status?.value}>
              {status?.label}
            </option>
          ))}
        </select>

        {/* View Mode Toggle */}
        <div className="flex items-center gap-2 p-1 bg-muted rounded-lg">
          <button
            onClick={() => onViewModeChange('grid')}
            className={`p-2 rounded transition-colors ${
              viewMode === 'grid' ? 'bg-card shadow-sm' : 'hover:bg-card/50'
            }`}
          >
            <Icon name="Grid3x3" size={18} />
          </button>
          <button
            onClick={() => onViewModeChange('list')}
            className={`p-2 rounded transition-colors ${
              viewMode === 'list' ? 'bg-card shadow-sm' : 'hover:bg-card/50'
            }`}
          >
            <Icon name="List" size={18} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default SearchFilters;